module.exports = __webpack_public_path__ + "no_search_new.f9f85.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/no_search_new.svg
// module id = ./src/_asset/sources/assets/images/@svg/no_search_new.svg
// module chunks = main